import { AppId, AppSwitcher } from '@revolut-internal/backoffice-provider'
import { TopNav } from '@revolut-internal/ui-kit'

import { AppRoute } from 'lib/router'

import { TopNavGlobalActions, TopNavLogo, TopNavProfile } from '../components'
import { nlpPlaygroundMenuItems } from '../RootProvider.constants'

export const useTopNav = () => ({
  logo: <TopNavLogo />,
  menu: (
    <TopNav.Menu
      defaultValue={AppRoute.Root}
      collapse="force"
      items={nlpPlaygroundMenuItems}
    />
  ),
  profile: <TopNavProfile />,
  appSwitcher: <AppSwitcher appId={AppId.CXLabs} />,
  globalActions: <TopNavGlobalActions />,
})
